import { IColors } from "@swiggy-private/dls-web-common/dist/components/types";
import styled from "styled-components";

interface IStyles {
    bgColor?: keyof IColors;
}

export const Container = styled.div<IStyles>(({ theme, bgColor = "background_Primary" }) => {
    return {
        marginTop: theme.spacing.large,
        width: "100%",
        backgroundColor: theme.colors[theme.colorMode][bgColor],
        borderRadius: theme.cornerRadius.medium,
        display: "flex",
        padding: theme.spacing.small,
    };
});

export const TextContainer = styled.div(({ theme }) => ({
    marginLeft: theme.spacing.xSmall,
}));
